import { Injectable, inject } from '@angular/core';
import { CollectionReference, DocumentReference, collection, doc, setDoc, updateDoc } from 'firebase/firestore';
import { FIREBASE_FIRESTORE } from '../firebase-config';
import { typedCollectionRef, typedDocRef } from './firestore-typed-helpers';

@Injectable({ providedIn: 'root' })
export class FirestoreDocumentService {
  private firestore = inject(FIREBASE_FIRESTORE);

  buildDocRef<T>(...pathSegments: string[]): DocumentReference<T> {
    return typedDocRef<T>(this.firestore, ...pathSegments);
  }

  buildCollectionRef<T>(...pathSegments: string[]): CollectionReference<T> {
    return typedCollectionRef<T>(this.firestore, ...pathSegments);
  }

  buildUserDocRef<T>(userId: string): DocumentReference<T> {
    return this.buildDocRef<T>('users', userId);
  }

  buildUserLocationDocRef(userId: string, locationId: string): DocumentReference {
    return doc(this.firestore, 'users', userId, 'locations', locationId);
  }

  buildUserLocationsCollectionRef(userId: string): CollectionReference {
    return collection(this.firestore, 'users', userId, 'locations');
  }

  buildNewLocationDocRef(locationsRef: CollectionReference): DocumentReference {
    return doc(locationsRef);
  }

  setDocument(reference: DocumentReference, data: unknown): Promise<void> {
    return setDoc(reference as never, data as never);
  }

  updateDocument(reference: DocumentReference, data: unknown): Promise<void> {
    return updateDoc(reference as never, data as never);
  }
}
